import { ENV } from 'src/environment';
import { config } from './config';

declare global {
  interface Window {
    _sift: {
      push: (...args: any) => void;
    };
  }
}

function setUser(userId: string, sessionId: string) {
  if (ENV === 'development') return;
  window._sift.push(['_setUserId', userId]);
  window._sift.push(['_setSessionId', sessionId]);
}

function trackPageView() {
  if (ENV === 'development') return;
  window._sift.push(['_trackPageview']);
}

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    const siftLibrary = document.createElement('script');
    siftLibrary.src = 'https://cdn.sift.com/s.js';
    siftLibrary.type = 'text/javascript';
    siftLibrary.id = 'sift-library';
    document.head.appendChild(siftLibrary);

    const siftVars = document.createElement('script');
    siftVars.type = 'text/javascript';
    siftVars.id = 'sift';
    siftVars.innerText = [
      `var _sift = window._sift = window._sift || [];`,
      `_sift.push(['_setAccount', '${config.beaconKey}']);`,
      `_sift.push(['_trackPageview']);`,
    ].join('');
    document.head.appendChild(siftVars);
    hasInitialized = true;
  }
  return { setUser, trackPageView };
})();
